export const COLORS = {
    primary:  '#64E43C',
    contrastPrimary: 'white'
  };